const doc = window.document;

export function trigger(name: string, data: any) {
  let event = doc.createEvent("CustomEvent");
  event.initCustomEvent(name, true, true, data);
  // args: string type, boolean bubbles, boolean cancelable, data
  return doc.dispatchEvent(event);
  // return doc.dispatchEvent(new CustomEvent(name, {bubbles: true, cancelable: true, detail: data}));
}

export function on(name: string, eventHandler: any) {
  // Подписываемся на событие
  doc.addEventListener(name, eventHandler, false);
}

export function one(name: string, eventHandler: Function) {
  const innerHandler = function (evt: any) {
    doc.removeEventListener(name, innerHandler);
    eventHandler.call(null, evt);
  };

  doc.addEventListener(name, innerHandler, false);

}

export function off(name: string, eventHandler: any) {
    doc.removeEventListener(name, eventHandler, false);
}
